export const COLORS = {
    blue: 'blue',
    red: 'red',
    green: 'green',
    black: 'black',
    white: 'white',
    gray: 'gray'
};
export const FONTS = {
    'Times New Roman': '"Times New Roman", Times, serif',
    'Comic Neue': '"Comic Neue", cursive',
    'Courier New': '"Courier New", Courier, monospace',
};
export const DEFAULT_RESPONSES = {
    title: '',
    mainTakeAway: '',
    useCase: '',
};
export const CORS_URL = 'https://cors-anywhere.herokuapp.com/';
export var TEXT_OPTIONS;
(function (TEXT_OPTIONS) {
    TEXT_OPTIONS[TEXT_OPTIONS["TEXT"] = 0] = "TEXT";
    TEXT_OPTIONS[TEXT_OPTIONS["URL"] = 1] = "URL";
})(TEXT_OPTIONS || (TEXT_OPTIONS = {}));
;
